<ng-container [formGroup]="form">
  <mat-form-field>
    <mat-label>Number Of Callers</mat-label>
    <input matInput formControlName="value" type="number" required />
    @if (form.get('value')?.hasError('required')) {
      <mat-error>Please enter a number</mat-error>
    }
  </mat-form-field>
</ng-container>
